import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useGetDriversBreakdownMutation } from "../../../store/api/lumi/drivers";
import { getConceptFilter } from "../../../utils/getConceptFilter";
import classes from "./LargestDriversMovement.module.css";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { debounce } from "lodash";
import { getComparingDates } from "../../../utils/getCompareDates";
import { Tooltip } from "antd";
import { ArrowRed } from "../../../icons/ArrowRed";
import { ArrowGreen } from "../../../icons/ArrowGreen";
import Scrollbars from "react-custom-scrollbars-2";

const AverageScoreChangeWidget = (props) => {
    const {
        id,
        selectedFieldDriverName,
        filters,
        seletctedType,
        selectedDateName,
        interval,
    } = props;

    const [loading, setLoading] = useState(true);
    const [scoreChanges, setScoreChanges] = useState([]);
    const [comparingDates, setComparingDates] = useState([]);

    const conceptFilter = useMemo(
        () => JSON.stringify(getConceptFilter(props)),
        [props],
    );

    const [getDriversBreakdown] = useGetDriversBreakdownMutation();

    const getDrivers = useCallback(async () => {
        setLoading(true);
        const { data } = await getDriversBreakdown({
            id,
            concept_selector: JSON.parse(conceptFilter),
            score_field: selectedFieldDriverName,
            filter: filters,
            match_type: seletctedType,
            breakdowns: [{ name: selectedDateName, interval }],
        });

        const breakdownData = data[0]?.buckets || [];
        const lastData = breakdownData[breakdownData.length - 1];
        const preLastData = breakdownData[breakdownData.length - 2];

        let calculatedComparingDates;
        if (preLastData === undefined) {
            calculatedComparingDates = getComparingDates(lastData, lastData, interval);
        } else {
            calculatedComparingDates = getComparingDates(preLastData, lastData, interval);
        }

        setComparingDates(calculatedComparingDates);

        const updatedScores = lastData?.drivers.map((driver) => {
            const preLastDriver = preLastData?.drivers.find(
                (c) => c.name === driver.name,
            );

            let changePercentage = 0;
            if (preLastDriver) {
                changePercentage =
                    ((driver.average_score - preLastDriver.average_score) /
                        preLastDriver.average_score) *
                    100;
            }

            return {
                ...driver,
                preLastDriver,
                changePercentage,
            };
        });

        const sortedDrivers = [...updatedScores].sort(
            (a, b) => Math.abs(b.changePercentage) - Math.abs(a.changePercentage),
        );

        setScoreChanges(sortedDrivers);
        setLoading(false);
    }, [
        filters,
        interval,
        selectedDateName,
        selectedFieldDriverName,
        seletctedType,
        conceptFilter,
    ]);

    useEffect(() => {
        const debouncedGetDrivers = debounce(getDrivers, 1000);
        debouncedGetDrivers();

        return () => {
            debouncedGetDrivers.cancel();
        };
    }, [getDrivers]);

    if (loading) {
        return (
            <Spin
                className={"spinner-by-center"}
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            />
        );
    }

    const height = props.widget.layout.h * 39 - 200;
    let EqualCompareDate = comparingDates[0] === comparingDates[1];

    return (
        <div className={classes.sentimentContainer}>
            <div className={classes.change_types_container}>
                <div className={classes.change_type_container}>
                    <div className={classes.change_type_items}>
                        <div className={classes.change_type}>
                            <div className={classes.gridHeader}>
                                <div className={classes.headerGridContainer}>
                                    <div className={classes.gridItemHeader}>Driver</div>
                                    <div className={classes.gridItemHeader}>Change</div>
                                    <div className={classes.gridItemHeader}>Date</div>
                                    <div className={classes.gridItemHeader}>Average Score</div>
                                </div>
                            </div>
                            <Scrollbars style={{ height: height }}>
                                <div className={classes.gridContainer} style={{ height }}>
                                    {scoreChanges.map((driver, index) => (
                                        <div key={driver.name + index} className={classes.gridRow}>
                                            <Tooltip title={driver.name}>
                                                <div
                                                    className={classes.gridItemConcept}
                                                    style={{ fontSize: "14px", cursor: "pointer" }}
                                                >
                                                    {driver.name}
                                                </div>
                                            </Tooltip>
                                            <div className={classes.gridItemChanges}>
                                                {!EqualCompareDate && (
                                                    driver.changePercentage >= 0 ? <ArrowGreen /> : <ArrowRed />
                                                )}
                                                <span style={{ fontSize: "14px", fontWeight: "400" }}>
                                                {EqualCompareDate
                                                    ? "0"
                                                    : Math.abs(driver.changePercentage).toFixed(1)}%
                                            </span>
                                            </div>
                                            <div className={classes.gridItemMovement}>
                                                <div className={classes.sentimentLastDate}>
                                                    {comparingDates[0]}
                                                </div>
                                                {!EqualCompareDate && (
                                                    <div className={classes.sentimentPreLastDate}>
                                                        {comparingDates[1]}
                                                    </div>
                                                )}
                                            </div>
                                            <div className={classes.gridItemMovement}>
                                                <div className={classes.sentimentLastDate}>
                                                    {driver.average_score.toFixed(2)}
                                                </div>
                                                <div className={classes.sentimentPreLastDate}>
                                                    {driver.preLastDriver.average_score.toFixed(2)}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Scrollbars>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AverageScoreChangeWidget;
